import { isLiveBlogPath } from 'lib/liveBlog';
import { getBodyItemComponent } from '../getBodyItemComponent';

const TABOOLA = 'taboola';
const BOX_RAIL = 'boxrail';
const BOX_FLEX = 'boxflex';

const isContentElement = (item) => !!item
  && (item.element === 'p'
    || item.element === 'ul'
    || item.element === 'ol'
    || (item.presentation && item.presentation.size && ['small', 'medium'].includes(item.presentation.size))
  );

const getContentCount = (section) => section.filter(isContentElement).length;

const getComponentWrapper = (amp, path, articlePublishDate, vertical) => (item, i) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  getBodyItemComponent(item, i, amp, path, articlePublishDate, vertical);

const getAdsToDisplay = (contentLength) => {
  // 0-2 paragraphs: no ads
  if (contentLength < 3) return [];

  // 3-4 paragraphs: boxrail only
  if (contentLength < 5) return [BOX_RAIL];

  // 5-6 paragraphs: taboola & boxrail
  if (contentLength < 7) return [TABOOLA, BOX_RAIL];

  // 7+ paragraphs: taboola & boxflex
  return [TABOOLA, BOX_FLEX];
};

export default function formatSections(amp, path, articlePublishDate, vertical) {
  return (sections) => sections.map((section) => {
    const contentCount = getContentCount(section);
    const ads = getAdsToDisplay(contentCount);
    const isLiveBlog = isLiveBlogPath(path);

    const formatted = {
      items: section.map(
        getComponentWrapper(amp, path, articlePublishDate, vertical),
      ),
      ad: {
        display: false,
      },
      taboola: false,
    };

    if (!ads.length) return formatted;

    if (ads.includes(TABOOLA) || isLiveBlog) {
      formatted.taboola = true;
    }

    if (ads.includes(BOX_RAIL)) {
      formatted.ad.display = true;
      formatted.ad.slot = BOX_RAIL;
    }

    if (ads.includes(BOX_FLEX)) {
      formatted.ad.display = true;
      formatted.ad.slot = BOX_FLEX;
    }

    return formatted;
  });
}
